const Portfolio_data = [
  {
    id: 1,
    category: "Front-End",
    totalLike: "600",
    title: "Tesla-Clone",
    info: " A simple Tesla clone using React , Redux toolkit. ",
    tech: " #React #Styled-components #React Hook #Redux toolkit ",
    image: "./image/portfolio-01.jpg",
    image1: "./image/portfolio-01.jpg",
    github: "https://github.com/Hau-Ha/Tesla-clone",
    demo: "https://6bi4w.csb.app/",
  },
  {
    id: 2,
    category: "Front-End",
    totalLike: "750",
    title: "Weather-app",
    image: "./image/portfolio-02.jpg",
    image1: "./image/portfolio-02.jpg",
    github: "https://github.com/Hau-Ha/weather-app",
    demo: "https://weather-app-hh.herokuapp.com/",
    info: " The project to start learning skills like HTML , CSS ,JS, ReactJS, REST API and Responsive. This software can allow users to see the weather for 5 consecutive days in cities around the world ",
    tech: " #HTML #CSS #JS #Responsive #ReactJS #REST API",
  },
  {
    id: 3,
    category: "Front-End",
    totalLike: "630",
    title: "Modest-PSD to HTML ",
    image: "./image/portfolio-03.jpg",
    image1: "./image/portfolio-08.jpg",
    github: "https://github.com/Hau-Ha/Modest-project",
    demo: "https://92e57.csb.app/",
    info: " Modest is a project that does not require much coding skills but needs a very good knowledge of CSS, HTML and Photoshop to be able to complete the project, diligence and patience are highly appreciated. If you can work with Photoshop, you can also work with Figma because it is completely equivalent",
    tech: " #HTML #CSS #Photoshop",
  },
  {
    id: 4,
    category: "Front-End",
    totalLike: "360",
    title: "Movie-Web",
    image: "./image/portfolio-04.jpg",
    image1: "./image/portfolio-10.jpg",
    github: "https://github.com/Hau-Ha/FilmChill-app",
    demo: "https://github.com/Hau-Ha/FilmChill-app",
    info: " Movie Chill is a rather complex project to practice working skills with React, redux toolkit and API. It is modelled from other movie streaming sites on the net  ",
    tech: " #React #SASS #React Hook #Redux toolkit  #Axios #REST API",
  },
  {
    id: 5,
    category: "Front-End",
    totalLike: "280",
    title: "Job-controller-app",
    image: "./image/portfolio-06.jpg",
    image1: "./image/portfolio-07.jpg",
    github: "https://github.com/Hau-Ha/job-prod",
    demo: "http://34.124.189.18:8083/login",
    info: "Full-stack project. The software allows users to create an account, create, read, update, and delete (CRUD) job and control it. ACC-TEST : ID: test@test.com pass:Qaz195200 ",
    tech: " #React  #Axios #REST API #Nodejs #JWT #Mongodb",
  },
  {
    id: 6,
    category: "Front-End",
    totalLike: "690",
    title: "My-portfolio",
    image: "./image/portfolio-11.jpg",
    image1: "./image/portfolio-11.jpg",
    github: "https://github.com/Hau-Ha/Portfolio-wed",
    demo: "https://hauhadev.herokuapp.com/",
    info: " It's a project to introduce myself and what I've been doing in the past    ",
    tech: " #React",
  },
];
export default Portfolio_data;
